import { render } from "./NetworkIssue.vue?vue&type=template&id=54399943"
import script from "./NetworkIssue.vue?vue&type=script&lang=js"
export * from "./NetworkIssue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/dmsfrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__